module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/73/assets/images/cafd438e5f3dad5818c633750085aeff.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_reassign.svg
// module id = bD59
// module chunks = 0